import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=4a3e22d1"
import script from "./legend.vue?vue&type=script&lang=js"
export * from "./legend.vue?vue&type=script&lang=js"
import style0 from "./legend.vue?vue&type=style&index=0&id=4a3e22d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports